import type { CloudEnvironmentDiscoverer } from '../types/CloudEnvironmentDiscoverer';
import { OfficeHrdCloudEnvironmentDiscoverer } from './OfficeHrdCloudEnvironmentDiscoverer';

let cloudEnvironmentDiscoverer: CloudEnvironmentDiscoverer;

export function getCloudEnvironmentDiscoverer(): CloudEnvironmentDiscoverer {
    if (!cloudEnvironmentDiscoverer) {
        cloudEnvironmentDiscoverer = new OfficeHrdCloudEnvironmentDiscoverer();
    }

    return cloudEnvironmentDiscoverer;
}
